// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2ngyL","right":"styles_right__2_at4"};